import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SideMenuService } from './sidemenu.service';
import { resolveMenuUrl } from '@/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(
    private router: Router,
    private sideMenuService: SideMenuService

  ) { }
  getCurrentUrl() {
    const currentUrl = this.router.url
    const path = currentUrl.split('?')[0].split('/').slice(0, 3).join('/')
    // Drill-down pages (plant detail, cluster) have no menu entry of their
    // own — resolve them to the list page whose permissions they inherit.
    return resolveMenuUrl(path)
  }
  getParentUrl() {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('?')[0].split('/');
    return urlSegments.slice(0, urlSegments.length - 1).join('/');
  }

  loadMenuFromLocalStorage() {
    const savedMenuString = localStorage.getItem('sideMenu');
    let menu: any
    if (savedMenuString) {
      menu = JSON.parse(savedMenuString)
      return menu
    } else {
      return null
    }
  }
  // Helper function to wait for menu availability
  waitForMenuInLocalStorage(): Promise<any> {
    const maxAttempts = 50; // give up after ~5s instead of polling forever
    return new Promise((resolve) => {
      let attempts = 0;
      const checkMenu = () => {
        const menuFromLocal = this.loadMenuFromLocalStorage();
        if (menuFromLocal) {
          resolve(menuFromLocal); // Resolve when menu is available
        } else if (attempts++ < maxAttempts) {
          setTimeout(checkMenu, 100); // Retry after 100 ms if not found
        } else {
          resolve(null); // Give up so callers can fall back to defaults
        }
      };
      checkMenu();
    });
  }
  findMenuPermissions(menu: any[], url: string): any {
    if (!menu) {
      return null;
    }
    for (let item of menu) {
      if (item.url === url) {
        return item
      }
      if (item.children && item.children.length > 0) {
        const childMatch = this.findMenuPermissions(item.children, url);
        if (childMatch) {
          return childMatch;
        }
      }
    }
    return null
  }
  async fetchFreshMenu(): Promise<any> {
    try {
      const response = await this.sideMenuService.fetchSideMenu().toPromise();

      if (response) {
        // Process menu same as sidebar does
        const processedMenu = response.map((item: any) => ({
          ...item,
          isExpanded: false,
          openInNewTab: false
        }));

        // Update localStorage
        localStorage.setItem('sideMenu', JSON.stringify(processedMenu));

        return processedMenu;
      }
      return null;
    } catch (error) {
      console.error('Error fetching menu:', error);
      // Fallback to localStorage if API fails
      return this.loadMenuFromLocalStorage();
    }
  }
}
